import React from 'react';
import PropTypes from 'prop-types';
import './IconFitContainer.scss';

const IconFitContainer = ({
  children,
  className = '',
  childStyle = {backgroundColor: '#FFFFFF', padding: '5px'},
  parentStyle = {padding: '6px', height: '40px', width: '40px'}
}) => {
  return (
    <div style={parentStyle} className={`Avada-Faq_FitIcon-Container ${className}`}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          width: '100%',
          height: '100%',
          ...childStyle
        }}
      >
        {children}
      </div>
    </div>
  );
};

IconFitContainer.propTypes = {
  children: PropTypes.node,
  childStyle: PropTypes.object,
  parentStyle: PropTypes.object,
  className: PropTypes.string
};

export default IconFitContainer;
